"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  standard: "\n    position: relative;\n    display: grid;\n    grid-template-columns: repeat(12, 1fr);\n    grid-column-gap: 20px;\n  ",
  mobile: "\n    display: grid;\n    grid-template-columns: 0px repeat(4, 1fr) 0px;\n    grid-column-gap: 16px;\n  ",
  desktop: "\n    position: relative;\n    display: grid;\n    grid-template-columns: auto repeat(12, 1fr) auto;\n    grid-column-gap: 20px;\n  ",
  fullview: "\n    position: relative;\n    display: grid;\n    grid-template-columns: auto repeat(12, 87px) auto;\n    grid-column-gap: 20px;\n  ",
  ob: "\n    position: relative;\n    display: grid;\n    grid-template-columns: auto repeat(12, 87px) auto;\n    grid-template-rows: auto 84.4% auto;\n    grid-column-gap: 20px;\n  "
};
exports.default = _default;